import { ActivityFeedSearchFiltersModal } from "./ActivityFeedSearchFiltersModal.js";
import { useMemo, useState } from "react";
import { Badge, Button, ButtonGroup, DateTimeRangePicker, Icon } from "@therms/atalaya";
import { IoClose } from "react-icons/io5";
import { jsx, jsxs } from "react/jsx-runtime";
import { MdManageSearch } from "react-icons/md";
//#region src/modules/shared/ActivityFeed/ActivityFeedSearchFilters.tsx
function ActivityFeedSearchFilters({ filtersState, setFiltersState, showLocations, showUsers }) {
	const [showAdvanceFilters, setAdvanceFilters] = useState(false);
	const filterCount = useMemo(() => (!!filtersState.locationId && 1 || 0) + (filtersState.userId && 1 || 0) + (filtersState.scope?.length || 0) + (filtersState.dateTimeRange?.start ? 1 : 0), [filtersState]);
	return /* @__PURE__ */ jsxs("div", {
		className: "",
		children: [/* @__PURE__ */ jsxs("div", {
			className: "gap-x-xxs pb-xxs inline-flex flex-wrap",
			children: [/* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(DateTimeRangePicker, {
				placeholder: "Date/Time Range",
				onChangeValue: (val) => {
					setFiltersState({ dateTimeRange: val });
				},
				onClearValue: () => setFiltersState({ dateTimeRange: {
					end: void 0,
					start: void 0
				} }),
				value: filtersState.dateTimeRange
			}) }), /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs(ButtonGroup, { children: [filterCount ? /* @__PURE__ */ jsxs(Button, {
				onClick: () => {
					setAdvanceFilters(!showAdvanceFilters);
				},
				size: "base",
				subtle: true,
				variant: "info",
				children: [/* @__PURE__ */ jsxs("span", {
					className: "pr-xxs",
					children: [/* @__PURE__ */ jsx(Badge, {
						value: filterCount,
						variant: "info"
					}), " Filters Applied"]
				}), /* @__PURE__ */ jsx(Icon, { Icon: MdManageSearch })]
			}) : /* @__PURE__ */ jsxs(Button, {
				onClick: () => {
					setAdvanceFilters(!showAdvanceFilters);
				},
				size: "base",
				subtle: true,
				variant: "neutral",
				children: [/* @__PURE__ */ jsx("span", {
					className: "pr-xxs",
					children: "Filters"
				}), /* @__PURE__ */ jsx(Icon, { Icon: MdManageSearch })]
			}), (!!filtersState.locationId || filtersState.dateTimeRange?.end || filtersState.dateTimeRange?.start || !!filtersState.scope?.length || !!filtersState.userId) && /* @__PURE__ */ jsxs(Button, {
				onClick: () => {
					setFiltersState({
						dateTimeRange: {
							end: void 0,
							start: void 0
						},
						locationId: void 0,
						scope: void 0,
						userId: void 0
					});
					setAdvanceFilters(false);
				},
				subtle: true,
				children: [/* @__PURE__ */ jsx(Icon, {
					color: "critical",
					Icon: IoClose
				}), " Clear"]
			})] }) })]
		}), showAdvanceFilters && /* @__PURE__ */ jsx(ActivityFeedSearchFiltersModal, {
			filtersState,
			onClose: () => setAdvanceFilters(false),
			setFiltersState,
			showLocations,
			showUsers
		})]
	});
}
//#endregion
export { ActivityFeedSearchFilters };

//# sourceMappingURL=ActivityFeedSearchFilters.js.map